import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT, Environment } from "../auth/auth.tokens";

@Injectable({ providedIn: 'root' })
export class ValidationEmailService {
  private options: Environment = inject(ENVIRONMENT);
    private apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = `${this.options.baseUrl.auth}`;
    }

  validateEmail(token: string): Observable<void> {
    return this.http.post<any>(`${this.apiUrl}/auth/validate-email`, { token });
  }
}
